import { Component } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ProjetIndicateur } from 'src/app/shared/models/projet';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Router } from '@angular/router';
import * as FileSaver from 'file-saver';
@Component({
  selector: 'app-tep-pdc',
  standalone: false,
  templateUrl: './tep-pdc.component.html',
  styleUrl: './tep-pdc.component.scss'
})


export class TepPdcComponent {

  items: any = [];
  firstProjets: number = 0;
  rowsProjets: number = 10;
  totalRecords: number = 0;
  paginatedProjets: any = [];
  user: any;
  directionItems: any = [];
  pdcData: any = [];
  directionId: any;
  isLoading: boolean = false;
  selectedPdc: any;
  annee: any;

  tepGlobale:any
  tepRealse:any
  constructor(
    private modalService: NgbModal,
    private paramservice: ParameterService,
    private localstorage: LocalStorageService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private ngxService: NgxUiLoaderService,
    private router: Router
  ) {
    //this.annee = this.localstorage.getExerciceToUserToSuivieEvaluation();

  }
  ngOnInit() {
    this.user = this.localstorage.getInfoUserToService()?.data;
    //console.log("  this.user", this.user);
    this.directionId = this.user?.service?.direction?.reference,
      this.getPdcListe();
    //  this.getDirection();
  }


  getPdcListe() {
    this.isLoading === false;
    this.paramservice.getPdcItems().subscribe(
      (response: any) => {
        this.pdcData = response.data;
        this.isLoading = true;
        //console.log("this.pdcData", this.pdcData);
      },
      (error) => {
        //console.log("une erreur est survenu", error);
      }
    );
  }

  getStatistique() {
    this.ngxService.start();
    const requestData = {
      nbr_annee: this.annee,
      pdc_id:this.selectedPdc.id,
      user_reference: this.user.reference,
      type_operation: 'data'
    }
    this.paramservice.getStatistiquePdc(requestData).subscribe(
      (response: any) => {
        this.ngxService.stop();
        // this.isLoading = false;
        this.items = response.data.details_annuels;
        console.log("this.items",this.items);

        this.tepGlobale =  response.data?.tep_global_prevu;
        this.tepRealse =  response.data?.tep_global_realise;
        
        //  this.totalRecords = this.projetData.length;
        this.updatePaginatedProjets();
      },
      (error) => {
        this.ngxService.stop();
        this.messageService.add({ severity: 'error', summary: 'TEP', detail: error, life: 3000 });
        //this.isLoading = false;
      }
    );
  }
  onPageChangeProjets(event: any) {
    this.firstProjets = event.page * this.rowsProjets; // Mise à jour de la page actuelle
    this.updatePaginatedProjets();
  }

  // Méthode pour mettre à jour les données paginées des projets
  updatePaginatedProjets() {
    const start = this.firstProjets;
    const end = start + this.rowsProjets;
    this.paginatedProjets = this.items.slice(start, end);
  }//end updatePaginatedProjets




  exportToDocument(typeDoc: any) {
    const requestData = {
      nbr_annee: this.annee,
      pdc_id:this.selectedPdc.id,
      user_reference: this.user.reference,
      type_operation: typeDoc

    }
    this.ngxService.start();

    this.paramservice.getStatistiquePdcEvaluation(requestData).subscribe(
      (response: Blob) => {
        let filename = '';
        let mimeType = '';
        let successMessage = '';

        if (typeDoc === 'pdf') {
          filename = 'Statistiques_pta_global.pdf';
          mimeType = 'application/pdf';
          successMessage = 'Le fichier PDF a été téléchargé avec succès';

          const blob = new Blob([response], { type: mimeType });
          const url = URL.createObjectURL(blob);
          window.open(url, '_blank');
        } else {
          filename = 'Statistiques_pta_global.xlsx';
          mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
          successMessage = 'Le fichier Excel a été téléchargé avec succès';

          const blob = new Blob([response], { type: mimeType });
          FileSaver.saveAs(blob, filename);
        }

        this.ngxService.stop();
        this.messageService.add({ severity: 'success', summary: 'Téléchargement réussi', detail: successMessage, life: 3000 });
      },
      (error) => {
        console.error('Une erreur est survenue', error);
        this.ngxService.stop();
      }
    );

  }

}
